import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetTransactionEvidenceEmailFileRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getTransactionEvidenceEmailFile = async (
  instance: AxiosInstance,
  params: DefaultApiGetTransactionEvidenceEmailFileRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getTransactionEvidenceEmailFile(params)
}
// Do Not Remove this line ===@import api client===
